import React, { useState } from 'react';
import Highlighter from 'react-highlight-words';
import { Modal, Button, Input, Icon, Table } from 'antd';
import { useDispatch } from 'react-redux';
import TextEvents from 'app/components/TextEvents';
import { Grid } from '@material-ui/core';
import { setCourseUsed } from '../../../actions/CourseAvailableActions';

const ModalProcedureAssignation = (props) => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const [selectedRowsAdd, setSelectedRowsAdd] = useState([]);
    const [rowKeysToAdd, setrowKeysToAdd] = useState([]);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);

    const dispatch = useDispatch();

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    }

    const handleReset = clearFilters => {
        clearFilters();
        setSearchText('');
    };

    const dataSource = props.courseAvailable.filter(x => !x.assigned).map(
        (record) => {
            return{
                'key': record.idCourse,
                'idCourse': record.idCourse,
                'nameWithCode': `${record.courseCode} - ${record.courseName} (Versión ${record.courseVersion})`
            }
        }
    );

    //Genera la estructura de búsqueda
    const getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input

                    placeholder={`Buscar procedimiento/material`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Buscar
                </Button>
                <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Limpiar
                </Button>
            </div>
        ),
        filterIcon: filtered => (
            <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            record[dataIndex]
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
        render: text =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text.toString()}
                />
            ) : (
                text
            ),
    });

    const onSelectChange = (selectedRowKeys, selectedRowsAdd) => {
        setrowKeysToAdd(selectedRowKeys)
        setSelectedRowsAdd(selectedRowsAdd);
        setSelectedRowKeys(selectedRowKeys);
        setSelectedRows(selectedRowsAdd);
    }

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        selectedRows: selectedRows,
        onChange: onSelectChange
    }

    const setAssigned = (item) => {
        dispatch(setCourseUsed(item));
    }

    const submit = () => {
        props.onChangeCourses(rowKeysToAdd, selectedRowsAdd);
        rowKeysToAdd.forEach(setAssigned);
        setrowKeysToAdd([]);
        setSelectedRowsAdd([]);
        setSelectedRowKeys([]);
        setSelectedRows([]);
        props.setVisibleModalProcedureAssign(false);
    }

    const cancel = () => {
        setrowKeysToAdd([]);
        setSelectedRowsAdd([]);
        setSelectedRowKeys([]);
        setSelectedRows([]);
        props.setVisibleModalProcedureAssign(false);
    }

    const columns = [
        {
            title: 'Nombre',
            dataIndex: 'nameWithCode',
            key: 'nameWithCode',
            ellipsis: true,
            ...getColumnSearchProps('nameWithCode')
        }
    ];

    return (
        <Modal
            destroyOnClose={true}
            onCancel={() => {
                setrowKeysToAdd([])
                setSelectedRowsAdd([]);
                setSelectedRowKeys([]);
                setSelectedRows([]);
                props.setVisibleModalProcedureAssign(false);
            }}
            visible={props.visibleModalProcedureAssign}
            title={
                <div>

                    <Grid container direction="row">
                        <Grid item xs={9}>
                            <TextEvents
                                text={'Seleccione Procedimiento/Material de capacitación'}
                                color='cotemar'
                                size='label'
                                weight='bold'
                            />
                        </Grid>
                        <Grid item xs={3}>
                            <TextEvents
                                text={'Asignados ' + (selectedRowsAdd.length + props.courseAvailable.filter(x => x.assigned).length ) + '/' + props.courseAvailable.length + ' Total'}
                                color='gray'
                                size='small'
                            />
                        </Grid>
                    </Grid>
                </div>
            }
            width={'800px'}
            centered={true}
            footer={[
                <Button disabled={selectedRowKeys.length === 0} key="submit" type="primary" loading={props.isLoadingSaveCourses} onClick={() => submit()} >
                    Asignar
                </Button>,
                <Button key="back" type="danger" ghost onClick={()=> cancel()}>
                    Cancelar
                </Button>
            ]}
        >
            <Table
                columns={columns}
                dataSource={dataSource}
                scroll={{ y: 300, x: 400 }}
                pagination={false}
                loading={props.isLoadingCourses}
                rowSelection={rowSelection}
            />
        </Modal>
    )
}

export default ModalProcedureAssignation;